/**
 * Service API pour le catalogue d'exercices (Module Seances v2).
 * Utilise le client axios partage du projet (services/api.js).
 */
import api from './api'

/**
 * Liste paginee d'exercices visibles par l'utilisateur connecte
 * (perso + club + templates systeme), avec filtres optionnels.
 *
 * @param {object} opts
 * @param {string} [opts.procede]            'echauffement' | 'jeu' | 'situation' | 'exercice' | 'match'
 * @param {string} [opts.category_tactique]  recherche exact
 * @param {string} [opts.search]             ILIKE sur name + description
 * @param {boolean} [opts.is_template]       filtre is_template true/false
 * @param {number} [opts.page=1]
 * @param {number} [opts.size=21]
 * @returns {Promise<{items, page, size, total, has_next}>}
 */
export async function listProcedes({
  procede, category_tactique, search, is_template, theme,
  page = 1, size = 21,
} = {}) {
  const params = {}
  if (procede) params.procede = procede
  if (category_tactique) params.category_tactique = category_tactique
  if (search) params.search = search
  if (typeof is_template === 'boolean') params.is_template = is_template
  if (theme) params.theme = theme
  params.page = page
  params.size = size
  const { data } = await api.get('/exercises/', { params })
  return data
}

/**
 * Liste des templates systeme (is_template=true).
 * Utilise par le toggle "Templates Insightball" du catalogue.
 */
export async function listProcedeTemplates({
  procede, category_tactique, search, theme, page = 1, size = 50,
} = {}) {
  const params = {}
  if (procede) params.procede = procede
  if (category_tactique) params.category_tactique = category_tactique
  if (search) params.search = search
  if (theme) params.theme = theme
  params.page = page
  params.size = size
  const { data } = await api.get('/exercises/templates/', { params })
  return data
}

export async function getProcede(id) {
  const { data } = await api.get(`/exercises/${id}/`)
  return data
}

export async function createProcede(payload) {
  const { data } = await api.post('/exercises/', payload)
  return data
}

export async function updateProcede(id, payload) {
  const { data } = await api.patch(`/exercises/${id}/`, payload)
  return data
}

export async function deleteProcede(id) {
  await api.delete(`/exercises/${id}/`)
}

export async function duplicateProcede(id) {
  const { data } = await api.post(`/exercises/${id}/duplicate/`)
  return data
}

/**
 * Extrait un message FR d'une erreur backend.
 * Le backend renvoie soit un detail string, soit un objet
 * {error, message} (format structure pour les erreurs metier).
 */
export function getErrorMessage(err, fallback = 'Une erreur est survenue.') {
  const detail = err?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (detail && typeof detail === 'object') {
    return detail.message || ERROR_MESSAGES_FR[detail.error] || fallback
  }
  return fallback
}

const ERROR_MESSAGES_FR = {
  invalid_procede: 'Le procédé sélectionné est invalide.',
  exercise_not_found: 'Ce procédé est introuvable.',
  template_protected: 'Les templates système ne peuvent pas être modifiés.',
  not_owner: 'Tu ne peux modifier que tes propres procédés.',
  max_blocks_reached: 'Une séance ne peut pas dépasser 6 procédés.',
}
